export function white(value = 1) {
  return `rgba(255, 255, 255, ${value}`;
}

export function black(value = 1) {
  return `rgba(0, 0, 0, ${value}`;
}

const lightBlues = {
  default: '#67baea',
  50: '#f7fcfe',
  100: '#c2e3f7',
  200: '#a4d6f2',
  300: '#85c8ee',
  400: '#67baea',
  500: '#439dd1',
  600: '#2582b8',
  650: '#247db1',
  700: '#0d699e',
  800: '#005485',
  900: '#00446b',
};

export function lightBlue(value = 400) {
  return lightBlues[value];
}

const greens = {
  default: '#00c070',
  50: '#ebfff5',
  100: '#ccf2e2',
  200: '#99e6c6',
  300: '#66d9a9',
  400: '#33cd8d',
  500: '#00c070',
  600: '#00ab55',
  700: '#00964b',
  800: '#008241',
  900: '#006e37',
};

export function green(value = 500) {
  return greens[value];
}

const greys = {
  default: '#9d9d9d',
  50: '#f7f7f7',
  100: '#ebebeb',
  200: '#dcdcdc',
  300: '#c7c7c7',
  400: '#bfbfbf',
  500: '#9d9d9d',
  600: '#808080',
  700: '#6d6d6d',
  800: '#404040',
  900: '#2d2d2d',
};

export function grey(value = 500) {
  return greys[value];
}

const warnings = {
  default: '#ffd600',
  light: '#fffde7',
  dark: '#f9a825',
};

export function warning(value = 'default') {
  return warnings[value];
}

const errors = {
  default: '#dd2c00',
  light: '#ffebee',
  dark: '#bf360c',
};

export function error(value = 'default') {
  return errors[value];
}

const infos = {
  default: '#0091ea',
  light: '#b3e5fc',
  dark: '#01579b',
};

export function info(value = 'default') {
  return infos[value];
}

const successes = {
  default: '#388eec',
  light: '#e8f5e9',
  dark: '#1b5e20',
};

export function success(value = 'default') {
  return successes[value];
}
